// Подсказки окна «Настройки команды». Сами команды — на сервере (/api/teams).

import { t } from "@/lib/i18n";

// подсказки под пустым состоянием
export const teamHints = [
  {
    icon: "ri-group-line",
    title: t("Группируйте сотрудников"),
    text: t("Команда — это набор пользователей, которым можно разом выдать доступ к диалогам и контактам."),
  },
  {
    icon: "ri-user-shared-line",
    title: t("Раздавайте вместо пользователей"),
    text: t("Вместо выбора каждого сотрудника по отдельности назначайте ответственных целой командой."),
  },
  {
    icon: "ri-shield-user-line",
    title: t("Права остаются личными"),
    text: t("Роль пользователя не меняется: команда только упрощает назначение диалогов и контактов."),
  },
];